import React from 'react';
import { Card } from '@hz-design-system/web-ui';

import TopSection from './TopSection/TopSection';
import ProfileHeroTabs from './ProfileHeroTabs/ProfileHeroTabs';
import Info from './Info/Info';
import type { SellerProfile, UserReviews } from '../../../../../types/SellerProfile';

import Classes from './ProfileHero.module.scss';

interface ProfileHeroProps {
  isUserViewingOwnProfile: boolean;
  sellerProfile: SellerProfile;
  editProfileUrl: string;
  loggedInUserId: number;
  onClickSaveControl: () => void;
  saveControlLoading: boolean;
  isSellerSaved: boolean;
  reviews: UserReviews[];
}

const ProfileHero = ({
  isUserViewingOwnProfile,
  sellerProfile,
  editProfileUrl,
  loggedInUserId,
  onClickSaveControl,
  saveControlLoading,
  isSellerSaved,
  reviews,
}: ProfileHeroProps) => {
  return (
    <section className={`${Classes.root} hz-Page-element hz-Page-element--full-width`}>
      <Card>
        <TopSection {...sellerProfile} />
        <Info
          sellerId={sellerProfile.id}
          sellerName={sellerProfile.title}
          isUserViewingOwnProfile={isUserViewingOwnProfile}
          editProfileUrl={editProfileUrl}
          location={sellerProfile.location}
          isSellerSaved={isSellerSaved}
          periodSinceRegistrationDate={sellerProfile.periodSinceRegistrationDate}
          isSaveSellerControlVisible={loggedInUserId !== sellerProfile.id}
          onClickSaveControl={onClickSaveControl}
          saveControlLoading={saveControlLoading}
          reviews={reviews}
          hasSellerProfile={sellerProfile.hasSellerProfile}
        />
        {sellerProfile.hasSellerProfile && (
          <div className={Classes.tabWrap}>
            <ProfileHeroTabs sellerId={sellerProfile.id} sellerName={sellerProfile.title} />
          </div>
        )}
      </Card>
    </section>
  );
};

export default ProfileHero;
